import { useReactiveVar } from "@apollo/client";
import { ThemeWrapper } from "@flixbus/honeycomb-react";
import {
  NavigationApp,
  ErrorBoundary,
  Notification,
  Navigation,
  isDarkThemeVar,
  isTestEnv,
  AuthProvider,
  StateProvider,
  TranslationProvider,
} from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import contractPartnerGuardLink from "./shared/helpers/contractPartnerGuardLink/contractPartnerGuardLink";
import typePolicies from "./state/typePolicies/typePolicies";
import Layout from "./ui/Layout";

export const AppContent: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <StateProvider
          fetchPolicy="cache-and-network"
          typePolicies={typePolicies}
          additionalLinks={[contractPartnerGuardLink]}
        >
          <Layout>
            <Navigation app={NavigationApp.MPO} isUsedInternal />
            <Router />
          </Layout>
          <Notification />
        </StateProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

const App: React.FC = () => {
  const isDarkTheme = useReactiveVar(isDarkThemeVar);

  // User is Cypress
  if (isTestEnv() && process.env.NODE_ENV !== "production") {
    return (
      <ThemeWrapper theme="flix" style={{ minWidth: "1200px" }}>
        <TranslationProvider usesCookies isUsedInternal>
          <AppContent />
        </TranslationProvider>
      </ThemeWrapper>
    );
  }

  return (
    <ThemeWrapper id="theme-wrapper" dark={isDarkTheme}>
      <TranslationProvider usesCookies isUsedInternal>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </TranslationProvider>
    </ThemeWrapper>
  );
};

export default App;
